<h1 class="zoom-area">We can't find the page you are looking for</h1>
<section class="error-container">
  <span class="four"><span class="screen-reader-text">4</span></span>
  <span class="zero"><span class="screen-reader-text">0</span></span>
  <span class="four"><span class="screen-reader-text">4</span></span>
</section>
<div class="link-container">
  <a routerLink="/" class="more-link">Back To Home</a>
</div>